import { ContentNode } from 'app/library/content-node/models/content-node.model';
import { SubentityStateModel } from 'app/projects/subentity/src/lib/models/subentity.state-model';

export class ModuleContentNodesStateModel extends SubentityStateModel {
    item: ContentNode = null;
    sortField: string = null;
    sortDirection: string = null;
}
